import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Uitnodiging } from '../../../uitnodiging/model/uitnodiging';
import {
  ParkourButtonComponent,
  ParkourDividerComponent,
  ParkourInfoCardComponent,
  ParkourPageGradientComponent,
} from '@parkour/ui';
import { TranslateModule } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { RolLabelPipe } from '../../../shared/pipes/rol-label.pipe';

@Component({
  standalone: true,
  selector: 'parkour-verzonden-detail',
  templateUrl: './uitnodiging-verzonden.component.html',
  imports: [
    ParkourPageGradientComponent,
    ParkourDividerComponent,
    ParkourInfoCardComponent,
    ParkourButtonComponent,
    TranslateModule,
    DatePipe,
    RolLabelPipe,
  ],
})
export class UitnodigingVerzondenComponent {
  @Input({ required: true }) uitnodiging!: Uitnodiging;
  @Output() verwijderUitnodiging = new EventEmitter<void>();

  onVerwijderUitnodiging() {
    this.verwijderUitnodiging.emit();
  }
}
